// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_bwp","toggleWrap":"styles_toggleWrap__1_XXQ","content":"styles_content__25x98","selectAreaCode":"styles_selectAreaCode__33uxk"};